// @flow

import produce from 'immer';

import {type StoreShapeType} from './types';
import Immutable from 'immutable';

const relatedTypes = {
  basic_team: {
    space: 'teamsArea',
    path: ['basicTeams'],
    useImmutable: true,
  },
  basic_user: {
    space: 'userArea',
    path: ['basicUsers'],
    useImmutable: true,
  },
  user: {
    space: 'userArea',
    path: ['usersv2', 'byId'],
    useImmutable: true,
  },
  lanes: {
    space: 'lanes',
    path: ['byId'],
    useImmutable: false,
  },
};

/* the reducer will search for the 'related' key in the action fields below */
const keysWithRelated = [
  'response',
  'item',
  'data',
  'policy',
  'version',
  'payload',
];

export const receiveRelatedItemsReducer = (
  state: StoreShapeType,
  action: any
) => {
  /*
    this crossSliceReducer is used to store the related items fetched with
    the main results. To be saved the related items have to be specified in
    the relatedTypes array.
     */

  if (
    action.type.startsWith('RECEIVE_') ||
    action.type === 'sweetAPI/executeQuery/fulfilled'
  ) {
    const actionKeys = Object.keys(action).filter((key) =>
      keysWithRelated.includes(key)
    );

    for (var j = 0; j < actionKeys.length; j++) {
      const actionContent = action[actionKeys[j]];
      if (Object.prototype.hasOwnProperty.call(actionContent, 'related')) {
        const related = actionContent.related;
        if (related != null) {
          const relatedNames = Object.keys(related);

          let toReturn = {
            ...state,
          };

          for (let i = 0; i < relatedNames.length; i++) {
            const relatedName = relatedNames[i];
            const relatedType = relatedTypes[relatedName];

            // lets not break the app if backend send a unknown related type
            if (relatedType != null) {
              const {space, path, useImmutable} = relatedType;

              if (useImmutable) {
                // update immutable redux space
                const toSave = Immutable.fromJS(related[relatedName]);
                toReturn[space] = state[space].setIn(
                  path,
                  state[space].getIn(path).merge(toSave)
                );
              } else {
                // update non-immutable redux space
                toReturn = produce(toReturn, (draft) => {
                  let target = draft[space];

                  for (let step of path) {
                    // walk through the path
                    target = target[step];
                  }

                  Object.keys(related[relatedName]).forEach(
                    (field) => (target[field] = related[relatedName][field])
                  );
                });
              }
            }
          }

          return toReturn;
        }
      }
    }
  }
  return state;
};
